//the below event is fired on product details page
"use client";
import { CURRENCY_CODE } from "@/lib/constant";
import { sendGTMEvent } from "@next/third-parties/google";
import { findDiscount, getItemCategories } from "@repo/lib/helpers";
import { useEffect, useRef } from "react";

const GTMViewItem = ({ item }) => {
  const prevItemRef = useRef(null);
  useEffect(() => {
    if (!item) return; // Avoid running if item is undefined/null

    const currentItemStr = JSON.stringify(item);

    if (prevItemRef.current === currentItemStr) return; // Skip if identical

    prevItemRef.current = currentItemStr; // Update previous reference

    const { sku, name, brand, price, salePrice, productOptions, categories } =
      item;
    const variantOptions = productOptions
      ?.map((group) => group.values.find((value) => value.selected)?.name)
      .filter(Boolean);

    sendGTMEvent({
      event: "view_item",
      currency: CURRENCY_CODE,
      value: price,
      items: [
        {
          item_id: sku,
          item_name: name,
          affiliation: "",
          coupon: "",
          discount: findDiscount(price, salePrice),
          index: 0,
          item_brand: brand || "",
          ...getItemCategories(categories),
          item_list_id: "",
          item_list_name: "",
          item_variant: variantOptions?.join(","),
          price: price,
          quantity: 1,
        },
      ],
    });
  }, [item]);

  return null;
};

export default GTMViewItem;
